var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.32 12.9l5.39 5.4c.337.4.31.99-.062 1.357s-.964.386-1.358.043l-5.38-5.38c-3.336 2.591-8.112 2.143-10.907-1.025-2.794-3.168-2.645-7.963.342-10.95 2.987-2.987 7.782-3.136 10.95-.342 3.168 2.795 3.616 7.571 1.025 10.907v-.01zM8 14c3.314 0 6-2.686 6-6s-2.686-6-6-6-6 2.686-6 6 2.686 6 6 6z"}));
}

Search.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Search;

Search.default = Search;
